import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import Header from "../../components/Header";
import FilterForm from "../../components/FilterForm/HistoryFilterForm";

import TableContainer from "@mui/material/TableContainer";

import DataTable from "./DataTable";
import { useEffect, useState } from "react";
import { API_URL } from "../../utils/config";
import { v4 as uuidv4 } from "uuid";
import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";

const Histroy = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const headCells = [
    "utility_code",
    "utility_name",
    "state_id",
    "commodity",
    "class",
    "start_date",
    "end_date",
    "ptc_rate",
    "uom"
  ];
  const [sourceData, setSourceData] = useState([]);
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isShowMonthly, setIsShowMonthly] = useState(true);

  
  const [filters, setFilters] = useState([
    {
      name: "utility_code",
      value: "",
    },
    {
      name: "state_id",
      value: "",
    },
    {
      name: "commodity",
      value: "",
    },
    {
      name: "class",
      value: ""
    },
    {
      name: "date",
      value: ["", ""],
    }
  ]);

  const handleSearch = (filters, _rows) => {
    const _intialRows = _rows ? _rows : sourceData;
    
    let dateFilteredData = _intialRows;
    const dateFilter = filters.find(filter => filter.name === "date");
    if (dateFilter && dateFilter.value[0] && dateFilter.value[1]) {
      const [startDate, endDate] = dateFilter.value;
      const startM = moment(startDate);
      const endM = moment(endDate);
      const isSameDay = startM.isSame(endM, "day");
      if (!isSameDay) {
        dateFilteredData = dateFilteredData.filter(item => 
          moment(item.start_date, "YYYY/MM/DD").isSameOrBefore(startDate, 'day') &&
          moment(item.end_date, "YYYY/MM/DD").isSameOrAfter(endDate, 'day')
        );
      }
    }
    
    const filteredData = dateFilteredData.filter((item) =>
      filters.every((filter) => {
        if (filter.name === "date") return true; 
        return filter.value !== "" ? item[filter.name] === filter.value : true;
      })
    );
    console.log(filteredData)
    return [...filteredData];
  };
  const handleReset = () => {
    setFilters([
      {
        name: "utility_code",
        value: "",
      },
      {
        name: "state_id",
        value: "",
      },
      {
        name: "commodity",
        value: "",
      },
      {
        name: "class",
        value: ""
      },
      {
        name: "date",
        value: [moment().subtract(1, 'months'), moment()]
      }
    ])
  };

  const [loading, setLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);

    useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const startDateParam = searchParams.get('startDate');
    const endDateParam = searchParams.get('endDate');

    if (startDateParam && endDateParam) {
      setFilters(prevFilters => 
        prevFilters.map(filter => 
          filter.name === "date" 
            ? { ...filter, value: [moment(startDateParam) , moment(endDateParam)]} 
            : filter
        )
      )
    }
  }, [location.search]); 

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        await getCurrentUser();
        const session = await fetchAuthSession();
        if (!session.tokens?.accessToken) {
          throw new Error("No access token available");
        }
        const token = session.tokens.accessToken.toString();
        const res = await fetch(`${API_URL}/ptc/history`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        const _rows = data.response.map((row) => ({ id: uuidv4(), ...row }));
        formataArray(_rows)
        // setIntialRows(_rows);
        // setRows(_rows);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
        if (error.name === "NotAuthorizedException" || error.message?.includes("not authenticated")) {
          navigate("/login");
        }
      }
    };
    getData();
  }, [navigate]);

  useEffect(() => {
    if (!sourceData.length) return;

    let baseData = sourceData;
    const displayData = isShowMonthly 
      ? baseData 
      : getMergedData(baseData); 
    
    const filtered = handleSearch(filters, displayData);
    setRows(filtered);
    
  }, [isShowMonthly, sourceData, filters]);


  const getMergedData = (data) =>{

    const mergedArray = [];
    const mergedGroups = {};

    data.forEach(item => {
        const groupKey = `${item.utility_name}|${item.utility_code}|${item.state_id}|${item.commodity}|${item.class}|${item.uom}`;
        if (!mergedGroups[groupKey]) mergedGroups[groupKey] = [];
        mergedGroups[groupKey].push(item);
    });

    Object.values(mergedGroups).forEach(group => {
        group.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
        
        let currentMerge = null;
        
        group.forEach(item => {
            if (!currentMerge) {
                currentMerge = { ...item };
            } else if (
                currentMerge.ptc_rate === item.ptc_rate &&
                currentMerge.end_date === item.start_date
            ) {
                currentMerge.end_date = item.end_date;
            } else {
                mergedArray.push(currentMerge);
                currentMerge = { ...item };
            }
        });
        if (currentMerge) {
            mergedArray.push(currentMerge);
        }
    });

    return mergedArray;
  }

  if (loading) {
    return (
      <Backdrop
        sx={(theme) => ({
          backgroundColor: "white",
          color: "inherit",
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  const convertToCSV = (data) => {
    const csvRows = [];
    const headerCellNames = [
      "Utility Code",
      "Utility Name",
      "State",
      "Commodity",
      "Class",
      "Start Date",
      "End Date",
      "PTC Rates",
      "UOM"
    ];
    csvRows.push(headerCellNames.join(","));

    // Add data rows
    data.forEach((row) => {
      const values = headCells.map((header) => JSON.stringify(row[header]));
      csvRows.push(values.join(","));
    });
    return csvRows.join("\n");
  };

  const downloadCSV = (data, filename = "table_data.csv") => {
    let _data = data;
    if (selected.length > 0) {
      _data = rows
        .map((row) => {
          const i = selected.find((select) => select === row.id);
          if (i) {
            return row;
          }
          return null;
        })
        .filter((row) => row !== null);
    }

    const csvData = convertToCSV(_data);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const formataArray = (originalArray) => {
    const today = new Date();
    const todayFormatted = `${today.getFullYear()}/${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}`;

    const preprocessedArray = originalArray.map(item => {
      let sortDate;
      if (item.last_updated) {
        sortDate = item.last_updated;
      } else if (item.start_time) {
        const [year, month, day] = item.start_time.substring(0, 10).split('-');
        sortDate = `${year}/${month}/${day}`;
      } else {
        sortDate = todayFormatted;
      }

      return {
        ...item,
        sortDate
      };
    });

    preprocessedArray.sort((a, b) => {
      if (a.utility_name !== b.utility_name) return a.utility_name.localeCompare(b.utility_name);
      if (a.utility_code !== b.utility_code) return a.utility_code.localeCompare(b.utility_code);
      if (a.class !== b.class) return a.class.localeCompare(b.class);
      return new Date(a.sortDate) - new Date(b.sortDate);
    });

    const fullArray = [];
    const groups = {};

    preprocessedArray.forEach(item => {
      const key = `${item.utility_name}|${item.utility_code}|${item.class}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });

    Object.values(groups).forEach(group => {
      group.sort((a, b) => new Date(a.sortDate) - new Date(b.sortDate));

      group.forEach((current, index) => {
        const newItem = { ...current };
        if (current.last_updated) {
          newItem.start_date = current.last_updated;
        } else if (current.start_time) {
          const [year, month, day] = current.start_time.substring(0, 10).split('-');
          newItem.start_date = `${year}/${month}/${day}`;
        } else {
          newItem.start_date = todayFormatted;
        }
        if (index < group.length - 1) {
          const nextItem = group[index + 1];
          if (nextItem.last_updated) {
            newItem.end_date = nextItem.last_updated;
          } else if (nextItem.start_time) {
            const [year, month, day] = nextItem.start_time.substring(0, 10).split('-');
            newItem.end_date = `${year}/${month}/${day}`;
          } else {
            newItem.end_date = todayFormatted;
          }
        } else {
          newItem.end_date = todayFormatted;
        }
        delete newItem.sortDate;

        fullArray.push(newItem);
      });
    });
    setSourceData(fullArray);
  }

  const handleSubmitFilter = (val) =>{
    const dateFilter = val.find(filter => filter.name === "date");
    if (dateFilter && dateFilter.value[0] && dateFilter.value[1]) {
      const [startDate, endDate] = dateFilter.value;
      const startM = moment(startDate);
      const endM = moment(endDate);
      const isSameDay = startM.isSame(endM, "day");
      if (isSameDay) {
        navigate("/dashboard", { replace: true });
        return;
      }
    }
    setFilterLoading(true);
    setTimeout(() => {
      setFilters(val);
      setFilterLoading(false);
    }, 1000);
  }

  return (
    <Box className="w-full h-full min-h-[100vh] bg-[#EAF4FC]">
      <Header />
      <div className="w-full flex justify-center">
        <div className="w-[92%]  bg-white">
          <FilterForm
            rows={rows}
            handleSubmit={handleSubmitFilter}
            handleReset={handleReset}
            filters={filters}
          />
        </div>
      </div>
      <div className="w-full pt-10 flex justify-center">
        <div className="w-[92%]  bg-white">
          <div className="table-header-div">
            <Button variant="contained" className="sm:!mx-6" onClick={() => downloadCSV(rows)}>
              Download List
            </Button>
            <div className="ml-6 sm:mr-6">
              <Select
                labelId="view-select-label"
                id="view-select"
                value={isShowMonthly ? "monthly" : "collapsed"}
                onChange={(e)=>{
                  setIsShowMonthly(e.target.value === "monthly" ? true : false)
                }}
              >
                <MenuItem value="monthly">Monthly View</MenuItem>
                <MenuItem value="collapsed">Collapsed View</MenuItem>
              </Select>
            </div>
          </div>

          <Box className="mt-10">
            <Paper>
              {filterLoading ? (
                <div style={{textAlign:"center"}}>
                  <CircularProgress color="inherit" style={{ margin:"80px 0"}} />
                </div>
              ) : (
                <TableContainer>
                  <DataTable
                    rows={rows}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </TableContainer>
              )}
            </Paper>
          </Box>
        </div>
      </div>
    </Box>
  );
};
export default Histroy;
